module.exports = __webpack_public_path__ + "static/media/bitcoin.adfb2448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/bitcoin.png
// module id = 658
// module chunks = 0